import {EffectivePermissionsContext} from "components/src/context/EffectivePermissionsContextProvider";
import {useContext} from 'react'

export function useEffectivePermissionsContext()
{
    const context = useContext(EffectivePermissionsContext);

    if (!context) {
        throw new Error(
            "useEffectivePermissionsContext must be used within the scope of EffectivePermissionsContext"
        );
    }

    return context;
}